import { apiClient } from "./client";

export type ActivityWindow = {
  id: string;
  weekday: number; // 1=Mon..7=Sun
  start_time: string; // HH:MM:SS
  end_time: string;
};

export type ActivityProfile = {
  id: string;
  organization_id: string;
  label: string;
  windows: ActivityWindow[];
};

export type ActivityWindowInput = {
  weekday: number;
  start_time: string;
  end_time: string;
};

export async function getActivityProfile(orgId: string): Promise<ActivityProfile> {
  const { data } = await apiClient.get<ActivityProfile>(
    `/api/v1/organizations/${orgId}/activity-profile`,
  );
  return data;
}

export async function replaceActivityProfile(
  orgId: string,
  label: string | null,
  windows: ActivityWindowInput[],
): Promise<ActivityProfile> {
  const { data } = await apiClient.put<ActivityProfile>(
    `/api/v1/organizations/${orgId}/activity-profile`,
    { label, windows },
  );
  return data;
}

export async function checkEffective(
  orgId: string,
  date: string,
  time: string,
): Promise<{ is_open: boolean; matched_window: ActivityWindow | null }> {
  const { data } = await apiClient.get<{
    is_open: boolean;
    matched_window: ActivityWindow | null;
  }>(`/api/v1/organizations/${orgId}/activity-profile/effective`, {
    params: { date, time },
  });
  return data;
}
